<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-app-bar v-scroll="onScroll" :fixed="scrolling">
                    <v-btn v-if="icon" disabled icon>
                        <v-icon>{{icon}}</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <slot name="actions"></slot>
                    <v-tooltip v-if="scrolling" bottom>
                      <template v-slot:activator="{on}">
                        <v-btn v-on="on" @click="$vuetify.goTo(0,)" icon>
                          <v-icon>mdi-arrow-up</v-icon>
                        </v-btn>
                      </template>
                      <span>Scroll to top</span>
                    </v-tooltip>
                    <Help>
                      <template v-slot:activator="{on}">
                        <v-btn v-on="on" icon>
                          <v-icon>help</v-icon>
                        </v-btn>
                      </template>
                    </Help>
                    <template v-if="extended" v-slot:extension>
                      <slot name="extension"></slot>
                    </template>
                </v-app-bar>
                <v-card-text>
                    <slot></slot>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "layout",
        components:{
          Help: () => import("@/components/viewTemplates/help")
        },
        props:{
            icon:{
                default:false
            },
            title:{
                default: "Title placeholder",
                type: String,
            },
            extended:{
              required: false,
              default: false,
              type: Boolean
            },
            disable_scroll:{
              required: false,
              default: false,
              type: Boolean
            }
        },
        data: () => ({
          scrolling: false,
        }),
        mounted(){

        },
        methods:{
          onScroll(event){
            if(this.disable_scroll)return;
            if(event.target.scrollingElement.scrollTop < 35){
              this.scrolling= false;
            }else if(!this.scrolling){
              this.scrolling = true;
            }
          }
        }
    }
</script>

<style scoped>

</style>
